import React, { useState } from 'react';
import { CalendarIcon } from 'lucide-react';
interface DateRangePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  className?: string;
}
const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  className = ''
}) => {
  const formatDate = (date: Date | null) => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value ? new Date(e.target.value) : null;
    onStartDateChange(dateValue);
  };
  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value ? new Date(e.target.value) : null;
    onEndDateChange(dateValue);
  };
  return <div className={`flex flex-col sm:flex-row gap-2 ${className}`} data-id="element-560">
      <div className="relative" data-id="element-561">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-562">
          <CalendarIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-563" />
        </div>
        <input type="date" className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-md block w-full pl-10 p-2.5" placeholder="From" value={formatDate(startDate)} onChange={handleStartDateChange} data-id="element-564" />
      </div>
      <div className="relative" data-id="element-565">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-566">
          <CalendarIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-567" />
        </div>
        <input type="date" className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white text-sm rounded-md block w-full pl-10 p-2.5" placeholder="To" value={formatDate(endDate)} onChange={handleEndDateChange} data-id="element-568" />
      </div>
    </div>;
};
export default DateRangePicker;